// Set Yönetimi sol sütunu — müşterinin veri seti kartları (ad · gösterge sayısı · çerçeve). Seçili
// kart `aria-pressed`; geçiş kararı (kaydedilmemiş taslak onayı) üst bileşende (KpiSetsPage).

import type { KpiSetWithCount } from "../../api/kpi";
import { KPI_COPY } from "../../lib/kpi-ui";

export function SetListCards(props: {
  sets: readonly KpiSetWithCount[];
  setId: string | null;
  onSwitch: (id: string) => void;
}): JSX.Element {
  const { sets, setId, onSwitch } = props;
  return (
    <ul style={{ listStyle: "none", margin: 0, padding: 0 }} aria-label="Veri setleri">
      {sets.map((s) => {
        const on = s.id === setId;
        return (
          <li key={s.id} style={{ marginBottom: 8 }}>
            <button
              type="button"
              aria-pressed={on}
              onClick={() => onSwitch(s.id)}
              className="rounded-lg text-left w-full"
              style={{
                padding: "10px 12px",
                border: `1px solid ${on ? "var(--color-primary)" : "var(--color-border)"}`,
                background: on
                  ? "color-mix(in srgb, var(--color-primary) 6%, white)"
                  : "var(--color-surface)",
                fontSize: "0.82rem",
                minHeight: 44,
                cursor: "pointer",
              }}
            >
              <b style={{ color: "var(--color-primary)", display: "block" }}>{s.name}</b>
              <span style={{ color: "var(--color-text-2)" }}>
                {s.indicatorCount} gösterge · {s.frameworkName ?? KPI_COPY.framework.none}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
